import {Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {RemoteResponse} from './api.service';
import {Student} from '../classes/student';
import {LocalStorageService} from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class StudentsService {
  private studentsSignal: WritableSignal<Student[]> = signal<Student[]>([]);

  public students: Signal<Student[]> = this.studentsSignal.asReadonly();

  constructor(
    private localStorage: LocalStorageService,
  ) {
    // Initialize students from local storage
    const students = this.localStorage.getStudents();
    if (students.length > 0) {
      this.studentsSignal.set(students);
    }
    else{
      this.studentsSignal.set([]);
    }
  }

  public getStudentsFromApi(response: RemoteResponse): void {
    const students = this.getStudentRemoteData(response);
    this.setStudents(students);
  }

  public setStudents(students: Student[]): void {
    this.localStorage.setStudents(students);
    this.studentsSignal.update(() => [...students]);
  }

  public addStudent(student: Student,): void {
    const students = this.studentsSignal();
    students.push(student);
    this.setStudents(students);
  }

  public getStudentByRequestKey(requestKey: string): Student | undefined {
    return this.studentsSignal().find(student => student.requestKey === requestKey);
  }

  public deleteStudent(student: Student): void {
    const students = this.studentsSignal();
    const index = students.findIndex(s => s.requestKey === student.requestKey);
    if (index !== -1) {
      students.splice(index, 1);
      this.setStudents(students);
    }
  }

  private getStudentRemoteData(response: RemoteResponse): Student[] {
    const remoteData = response.data[0].dataSet;
    const students: Student[] = [];
    remoteData.students?.forEach((student: any) => {
      const studentObj = new Student();
      studentObj.setStudent({
        email: student.email,
        name: student.name,
        firstName: student.firstName,
        lastName: student.lastName,
        requestKey: student.requestKey,
        avatarUrl: student.avatarUrl,
      });
      students.push(studentObj);
    });

    return students;
  }
}
